/**
 * PreDesignReportHost — listens for `generate-predesign-report` (detail.projectId) and renders the
 * native Pre-Design Research PDF, opening it in a new tab. Mounted once in OutlineView. Dispatched
 * from the parcel ⋯ menu and the Parcel Research tool's Generate Report button (CT-020).
 */
import { useEffect, useState } from 'react'
import { generatePreDesignReport, previewPreDesignReport } from '../services/predesign.js'
import { alertDialog } from './Dialog.jsx'

export default function PreDesignReportHost() {
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    async function onGen(e) {
      const projectId = e && e.detail && e.detail.projectId
      if (!projectId) { await alertDialog({ title: 'No project', message: 'Could not resolve the project for this parcel.' }); return }
      if (busy) return
      setBusy(true)
      // Open the tab synchronously so the browser does not block it, then point it at the PDF.
      const tab = window.open('', '_blank')
      try {
        // detail.preview → working-draft copy (the milestone ⋯ "Preview"); else the issued copy.
        const res = await (e.detail && e.detail.preview ? previewPreDesignReport(projectId) : generatePreDesignReport(projectId))
        if (res.error) { if (tab) tab.close(); await alertDialog({ title: 'Report failed', message: res.error }) }
        else if (tab) tab.location = res.pdfUrl
        else window.open(res.pdfUrl, '_blank')
      } catch (err) {
        if (tab) tab.close()
        await alertDialog({ title: 'Report failed', message: (err && err.message) || 'Could not generate the report.' })
      }
      setBusy(false)
    }
    window.addEventListener('generate-predesign-report', onGen)
    return () => window.removeEventListener('generate-predesign-report', onGen)
  }, [busy])

  return null
}
